<template>
    <div>
        <div id="app" v-bind:class="{blurred:
        ($root.confirmDialog.active || $root.alertDialog.active)
        || (state && state.showProgress)}">
            <router-view/>
            <md-dialog-confirm
                    :md-active.sync="$root.confirmDialog.active"
                    :md-title="$root.confirmDialog.title"
                    :md-content="$root.confirmDialog.content"
                    md-confirm-text="Potwierdź"
                    md-cancel-text="Anuluj"
                    @md-cancel="$root.confirmDialog.active = false"
                    @md-confirm="$root.confirmDialog.onConfirm"/>
            <md-dialog-alert
                    class="md-dialog-alert"
                    :md-active.sync="$root.alertDialog.active"
                    :md-title="$root.alertDialog.title"
                    :md-content="$root.alertDialog.content"
                    md-confirm-text="OK"
                    @md-confirm="$root.alertDialog.active = false"/>
        </div>
        <div class="spinner-container" v-if="state && state.showProgress">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </div>
    </div>
</template>

<script>
import store from './store';


export default {
  name: 'App',
  data: () => ({
    state: store.state.utils,
  }),
  computed: {
    getState() {
      return store.state.utils;
    },
  },
  watch: {
    getState: {
      handler(state) {
        this.state = state;
      },
      deep: true,
    },
  },
  methods: {
  },
  created() {
    switch (this.$route.query.lang) {
      case 'pl': {
        this.$i18n.locale = 'pl-Pl';
        break;
      }
      case 'en': {
        this.$i18n.locale = 'en-En';
        break;
      }
      default: {
        break;
      }
    }
  },
};
</script>

<style lang="scss">
    #app {
        height: 100vh;

        &.blurred {
             pointer-events: none;
             overflow: hidden;
             -webkit-filter: blur(5px) brightness(60%);
             filter: blur(5px) brightness(60%)
         }
    }

    .spinner-container {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        text-align: center;
        overflow: hidden;

        .md-progress-spinner {
            z-index: 10;
            margin: auto;
        }
    }

    img {
        width: 100px;
    }
</style>

<style lang="scss" src="./mixins.scss"></style>
<style lang="scss" src="./global-styles.scss"></style>
<style lang="scss" src="./vue-material.scss"></style>



// WEBPACK FOOTER //
// src/App.vue